/**
 * payScale 조회 키를 생성한다.
 * classType이 없으면 "PRIVATE_REGULAR"로, isOt가 없으면 false로 기본 처리한다.
 * isOt=true이면 키에 "-OT" 접미사를 추가한다.
 *
 * @ClassType-values — 기본값 "PRIVATE_REGULAR"
 */
export function payScaleKey(memberType, classType, isOt) {
    const base = `${memberType}-${classType ?? "PRIVATE_REGULAR"}`;
    return isOt ? `${base}-OT` : base;
}
/**
 * 문자열을 ClassType으로 정규화한다.
 * 레거시 값("private", "group", "REGULAR")을 현재 값으로 변환한다.
 * "OT"는 ClassType이 아니므로 PRIVATE_REGULAR로 fallback한다.
 *
 * @ClassType-values — ClassType 값이 변경되면 이 매핑 테이블도 반드시 업데이트해야 합니다.
 * 현재 값: "PRIVATE_REGULAR" | "GROUP_REGULAR" | "TRIAL_COUNSEL"
 * 레거시 값: "private" | "group" | "REGULAR" | "OT" | "ot"
 */
export function normalizeClassType(value) {
    if (!value)
        return "PRIVATE_REGULAR";
    switch (value) {
        case "GROUP_REGULAR":
        case "group":
            return "GROUP_REGULAR";
        case "TRIAL_COUNSEL":
            return "TRIAL_COUNSEL";
        case "PRIVATE_REGULAR":
        case "private":
        case "REGULAR":
            return "PRIVATE_REGULAR";
        // OT는 ClassType이 아님 → PRIVATE_REGULAR fallback
        case "OT":
        case "ot":
            return "PRIVATE_REGULAR";
        default:
            return "PRIVATE_REGULAR";
    }
}
/** @deprecated normalizeClassType을 사용하세요. */
export function normalizeClassFormat(value) {
    return normalizeClassType(value);
}
//# sourceMappingURL=branch.js.map